import { APIRepository } from "~/context/Shared/infrastructure/APIRepository";
import { vectiAppApiUrl } from "~/context/Shared/infrastructure/Config";
import { TaxesDataRepository } from "../domain/TaxesDataRepository";
import { InvoiceSumCompraVentaByYearMonthType } from "~/context/InvoicesData/domain/InvoiceSumCompraVentaByYearMonthType";


export function createApiTaxesDataRepository(): TaxesDataRepository {
  return new ApiTaxDataRepository();
}

export class ApiTaxDataRepository extends APIRepository implements TaxesDataRepository {
  constructor() {
    super(vectiAppApiUrl());
  }

  getResumeTaxesYearMonthTypeByCompany(companyUid: string): Promise<InvoiceSumCompraVentaByYearMonthType>{
    if (companyUid == null || companyUid == undefined || companyUid == "") {
      throw new Error("CompanyUid is null or undefined");
    } else {
      return this.doGet<InvoiceSumCompraVentaByYearMonthType>("/api/taxesdata/company/" + companyUid.toString() + "/resumeCreditoDebitoLREBHByYearMonthType" );
    }
  }



}
